import { VidioHelpers } from 'shared/vidio_helpers';
import AhoyTracker from 'shared/ahoy_tracker';

export default class LivestreamingRelatedEventStream {
  constructor(options) {
    this.$container = options.$element;
    this.container = options.element;
  }

  init() {
    this.loadData();
  }

  loadData() {
    var livestreaming_id = this.container.dataset.livestreamingId;
    var url = `/live/related_event_stream/${ livestreaming_id }.html`;
    $.get(url)
      .done(data => { this.modifyElement(data); })
      .fail(e => {console.error(e); /*jshint ignore:line*/});
  }

  modifyElement(element) {
    try {
      var el = $.parseHTML(element)[0];
      var $element = $(el);

      if(this.hasContent($element)) {
        this.$container.after($element);
        this.initJsAhoy();
      }

      this.$container.remove();
    } catch(e) {
      console.warn('cannot parsed element!!', e);
    }
  }

  hasContent($element) {
    if (VidioHelpers.isMobile()) {
      return $element.find('.b-section__item').length > 0;
    }
    return $element.find('.livestreaming-events__item').length > 0;
  }

  initJsAhoy() {
    let elements = this.$container.find('.js-ahoy');

    for(var i = 0; i < elements.length; i++) {
      let element = elements[i];
      if(element.dataset.ahoyloaded !== 'true'){

        var ahoy_tracker = new AhoyTracker(element);
        ahoy_tracker.init();

        element.dataset.ahoyloaded = 'true';
      }
    }
  }
}
